import { Tag } from 'antd';
import React from 'react';
import { IntlMessages } from '@/components';
import { DATE_TIME_FORMAT } from '../const/system';
import getFormattedDate from './getFormattedDate';

export const renderDatetimeColumnWithUtcZeroTimeBool = (value, item, datetimeColumnKey = 'released_at') => {
  return (
    <>
      <div>{getFormattedDate(value, DATE_TIME_FORMAT)}</div>
      {item[datetimeColumnKey] && (
        <div>
          {item.use_utc_zero_time ? (
            <Tag color="default">
              <IntlMessages id="features-utc" />
            </Tag>
          ) : (
            ''
          )}
        </div>
      )}
    </>
  );
};
